export default window.bootstrapvalidation = function bootstrapvalidation() {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName("needs-validation");
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
            "submit",
            function (event) {
                const fileInput = this.querySelector("#allegato");
                let fileisvalid = 1;
                if (fileInput) {
                    const allowedExtensions = [
                        "pdf",
                        "dxf",
                        "step",
                        "dwg",
                        "igs",
                    ];
                    const fileExtension = fileInput.value
                        .split(".")
                        .pop()
                        .toLowerCase();

                    if (fileInput.value != "") {
                        if (fileInput.files.length > 0) {
                            const fileSize = fileInput.files[0].size;
                            if (fileSize > 20480 * 1024) {
                                // Handle invalid file size
                                fileisvalid = 0;
                            }
                        }
                    }

                    if (
                        !allowedExtensions.includes(fileExtension) &&
                        fileInput.value != ""
                    ) {
                        // Handle invalid file extension
                        fileisvalid = 0;
                    }
                }
                if (form.checkValidity() === false || fileisvalid === 0) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (fileisvalid === 0) {
                        fileInput.setCustomValidity("Invalid field.");
                    }
                }
                form.classList.add("was-validated");
            },
            false
        );
    });
};

(function () {
    "use strict";
    window.addEventListener(
        "load",
        function () {
            bootstrapvalidation();
        },
        false
    );
})();
